export const endpoints = {
  companyLogos: 'https://logos.steppingblocks.com/company/',
}
